import React from "react";
import {
  Badge,
  Button,
  Form,
  InputGroup,
  Table,
  Spinner,
  Col,
} from "react-bootstrap";
import { withTranslation } from "react-i18next";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import CamplaCoreService from "../../../../services/CamplaCoreService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import TypeAheadInput from "../../../../components/typeahead/Typeahead";

class UpdateGroupDialog extends React.Component {
  constructor(props) {
    super(props);
    this.validationDefinition = {
      name: {
        defaultValue: "",
        rule: ValidationHelper.isGroupName,
      },
      members: {
        defaultValue: [],
        rule: ValidationHelper.isMemberArrayGroup,
      },
      description: {
        defaultValue: "",
        rule: ValidationHelper.isDescription,
      },
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition),
      newMemberEmail: "",
      newMemberName: "",
      newMemberUserId: "",
      newMemberValid: false,
      addedMembers: new Set(),
      clear: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
    this.handleAddMember = this.handleAddMember.bind(this);
    this.handleRemoveMember = this.handleRemoveMember.bind(this);
    this.handleCheckEmail = this.handleCheckEmail.bind(this);
  }

  async handleCheckEmail(email) {
    if (ValidationHelper.isEmail(email)) {
      try {
        const foundMembers = this.props.users.filter(
          (user) => user.email === email
        );
        if (foundMembers.length > 0) {
          this.setState({
            newMemberValid: true,
            newMemberEmail: foundMembers[0].email,
            newMemberUserId: foundMembers[0]._id,
          });
          return;
        }
      } catch (err) {
        console.log(err);
      }
    }
    this.setState({ newMemberValid: false });
  }

  handleAddMember() {
    if (
      this.state.newMemberValid &&
      this.state.newMemberUserId.length > 0 &&
      !this.state.addedMembers.has(this.state.newMemberEmail)
    ) {
      const updatedMembers = [
        {
          userId: this.state.newMemberUserId,
          email: this.state.newMemberEmail,
        },
        ...this.state.validation.members.value,
      ];
      const addedMembers = new Set(updatedMembers.map((s) => s.email));
      this.setState({
        addedMembers: addedMembers,
        validation: ValidationHelper.update(
          {
            target: {
              name: "members",
              value: updatedMembers,
            },
          },
          this.state.validation
        ),
      });
      this.setState({ newMemberEmail: "", clear: true });
    }
  }

  handleRemoveMember(member) {
    const updatedMembers = this.state.validation.members.value.filter(
      (mb) => mb.userId !== member.userId
    );
    const addedMembers = new Set(updatedMembers.map((s) => s.email));
    this.setState({
      addedMembers: addedMembers,
      validation: ValidationHelper.update(
        {
          target: {
            name: "members",
            value: updatedMembers,
          },
        },
        this.state.validation
      ),
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.show && this.props.show !== prevProps.show) {
      const classData = this.props.class || {};
      const group = this.props.userGroupMaps.get(classData._id) || [];

      const membersVal = group
  .filter(Boolean)
  .map((el) => ({
    userId: el._id,
    email: el.email,
  }));

      this.setState({
        newMemberEmail: "",
        newMemberName: "",
        newMemberUserId: "",
        newMemberValid: false,
        addedMembers: new Set(),
        validation: ValidationHelper.getValidation(
          {
            name: {
              defaultValue: this.props.class.name,
              rule: ValidationHelper.isClassName,
            },
            members: {
              defaultValue: membersVal,
              rule: ValidationHelper.isMemberArrayGroup,
            },
            description: {
              defaultValue: this.props.class.description,
              rule: ValidationHelper.isDescription,
            },
          },
          true
        ),
      });
    } else if (!this.props.show && this.props.show !== prevProps.show) {
      this.setState({
        validation: ValidationHelper.getValidation(
          this.validationDefinition,
          true
        ),
      });
    }
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation),
    });
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["userId"] = CamplaCoreService.getAuthenticatedUser()._id;
      this.props.onSubmit(validatedData);
    }
  }

  render() {
    const { t } = this.props;

    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={t("Groups.GroupModal.UpdateModalTitle")}
        dialogApiError={this.props.dialogApiError}
        rightButtonText={t("Groups.GroupModal.DeleteModal.Submit")}
        rightButtonVariant="green"
        leftButtonVariant="black"
        leftButtonText={t("Groups.GroupModal.DeleteModal.Cancel")}
        leftButtonCallback={this.onHide}
        rightButtonDisabled={!this.state.validation._isValid}
        body={
          <div style={this.props.isUpdating ? { textAlign: "center" } : {}}>
            {this.props.isUpdating ? (
              <Spinner animation="border" />
            ) : (
              <Form>
                <Form.Group controlId="formClassName">
                  <Form.Label>
                    {t("Groups.GroupModal.UpdateModal.Groupname")}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    placeholder={t(
                      "Groups.GroupModal.UpdateModal.GroupNamePlaceholder"
                    )}
                    value={this.state.validation.name.value}
                    isInvalid={!this.state.validation.name.isValid}
                    onChange={this.handleChange}
                  />
                  <Form.Control.Feedback type="invalid">
                    {t("Groups.GroupModal.ValidationError.Name")}
                  </Form.Control.Feedback>
                </Form.Group>
                <Form.Group>
                  <Form.Label>
                    {t("Groups.GroupModal.UpdateModal.Description")}
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={4}
                    name="description"
                    value={this.state.validation.description.value}
                    style={{
                      resize: "none",
                      textAlign: "left",
                      paddingLeft: "10px",
                    }}
                    isInvalid={!this.state.validation.description.isValid}
                    onChange={this.handleChange}
                    placeholder={t("Groups.GroupModal.Form.GroupDescriptionPlaceholder")}
                  />
                </Form.Group>
                <p>
                  {t("Groups.GroupModal.Form.Members")}
                  <Badge variant="secondary" className="ml-1">
                    {this.state.validation.members.value
                      ? this.state.validation.members.value.length
                      : 0}
                  </Badge>
                </p>
                <InputGroup>
                  <Col className="p-0">
                    <TypeAheadInput
                      validation={this.state.validation}
                      users={this.props.users}
                      handleAddMember={this.handleAddMember}
                      valid={this.state.newMemberValid}
                      emptyLabel={t("Groups.GroupModal.CreateModal.emptyLabel")}
                      promptText={t("Groups.GroupModal.CreateModal.promptText")}
                      placeholder={t(
                        "Groups.GroupModal.CreateModal.placeholder"
                      )}
                      onSelected={(selected) => {
                        this.setState({
                          newMemberEmail: selected[0],
                        });
                        this.handleCheckEmail(selected[0]);
                      }}
                      clear={this.state.clear}
                      onClear={() =>
                        this.setState({
                          clear: false,
                          newMemberEmail: "",
                          newMemberUserId: "",
                          newMemberValid: false,
                        })
                      }
                    />
                  </Col>
                  <InputGroup.Append>
                    <Button
                      variant="btn btn-green"
                      disabled={!this.state.newMemberValid}
                      onClick={this.handleAddMember}
                      style={{
                        borderBottomLeftRadius: "0px",
                        borderTopLeftRadius: "0px",
                      }}
                    >
                      <FontAwesomeIcon icon={faPlus} />
                    </Button>
                  </InputGroup.Append>
                </InputGroup>
                <Table size="sm" className="students-table mt-2">
                  <thead>
                    <tr>
                      <th>
                        {this.props.t("Groups.GroupModal.Form.ColumnEmail")}
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.validation.members.value.map((m, idx) => (
                      <tr key={idx}>
                        <td>{m.email}</td>
                        <td>
                          <Button
                            className="btn btn-red btn-sm floatRight"
                            onClick={() => this.handleRemoveMember(m)}
                          >
                            <FontAwesomeIcon icon={faTrash} />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </Form>
            )}
          </div>
        }
      />
    );
  }
}

export default withTranslation()(UpdateGroupDialog);
